import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import {
  SYSTEM,
  CLIENT_WEB,
  CLIENT_MOBILE,
  FREEFORM_NAMESPACE,
  ORDER_NAMESPACE,  
} from "../constants/i18n-namespaces";
import {
  enCommon,
  enMenu,
  enLanguageModal,
  enAboutModal,
  enBillerLogo,
  enValidate,
  enBillModal,
  enHelpModal,
  enBalanceFrame,
  enContactTocFooter,
  enDonation,
  enBankAccountModal,
  enPayableDetails,
  enCreditDebitModal,
  enCashModal,
  enBarcodeView,
  enEmailView,
  enSmsView,
  enRetailerView,
  enPaymentAmountModal,
  enPaymentMethodModal,
  enReviewChargesModal,
  enReceiptInfoModal,
  enPaymentReceipt,
  enPayslipView,
  enManagePaymentMethodsModal,
  enPaymentDateModal,
  enUnsubscribeAlerts,
  enLinkExpired,
  enRecentPayments,
  enSessionTimeout,
  enLookup,
  enOrder,
  enFreeform,
  enLookupInfoImageModal,
  enPayableSelect,
  enSelectPaymentMethodModal,
  enSearchPath,
  enPayableReview,
  enItemVoidedArchived,
  enUnableToLoadAmountsModal
} from "./en-US";
import {
  esCommon,
  esMenu,
  esLanguageModal,
  esAboutModal,
  esBillerLogo,
  esValidate,
  esBillModal,
  esHelpModal,
  esBalanceFrame,
  esContactTocFooter,
  esDonation,
  esBankAccountModal,
  esPayableDetails,
  esCreditDebitModal,
  esCashModal,
  esBarcodeView,
  esEmailView,
  esSmsView,
  esRetailerView,
  esPaymentAmountModal,
  esPaymentMethodModal,
  esReviewChargesModal,
  esReceiptInfoModal,
  esPaymentReceipt,
  esPayslipView,
  esManagePaymentMethodsModal,
  esPaymentDateModal,
  esUnsubscribeAlerts,
  esLinkExpired,
  esRecentPayments,
  esSessionTimeout,
  esLookup,
  esOrder,
  esFreeform,
  esLookupInfoImageModal,
  esPayableSelect,
  esSelectPaymentMethodModal,
  esSearchPath,
  esPayableReview,
  esItemVoidedArchived,
  esUnableToLoadAmountsModal
} from "./es-US";
import {
  frCommon,
  frMenu,
  frLanguageModal,
  frAboutModal,
  frBillerLogo,
  frValidate,
  frBillModal,
  frHelpModal,
  frBalanceFrame,
  frContactTocFooter,
  frDonation,
  frBankAccountModal,
  frPayableDetails,
  frCreditDebitModal,
  frCashModal,
  frBarcodeView,
  frEmailView,
  frSmsView,
  frRetailerView,
  frPaymentAmountModal,
  frPaymentMethodModal,
  frReviewChargesModal,
  frReceiptInfoModal,
  frPaymentReceipt,
  frPayslipView,
  frManagePaymentMethodsModal,
  frPaymentDateModal,
  frUnsubscribeAlerts,
  frLinkExpired,
  frRecentPayments,
  frSessionTimeout,
  frLookup,
  frOrder,
  frFreeform,
  frLookupInfoImageModal,
  frPayableSelect,
  frSelectPaymentMethodModal,
  frSearchPath,
  frPayableReview,
  frItemVoidedArchived,
  frUnableToLoadAmountsModal
} from "./fr-CA";
import {
  COMMON_NAMESPACE,
  MENU_NAMESPACE,
  LANGUAGE_MODAL_NAMESPACE,
  ABOUT_MODAL_NAMESPACE,
  BILLER_LOGO_NAMESPACE,
  VALIDATE_NAMESPACE,
  BILL_MODAL_NAMESPACE,
  HELP_MODAL_NAMESPACE,
  BALANCE_NAMESPACE,
  CONTACT_TOC_FOOTER,
  DONATION,
  BANK_ACCCOUNT_MODAL,
  PAYABLE_DETAILS_NAMESPACE,
  CREDIT_DEBIT_MODAL,
  CASH_MODAL,
  BARCODE_VIEW,
  EMAIL_VIEW,
  SMS_VIEW,
  RETAILER_VIEW,
  PAYMENT_AMOUNT_MODAL_NAMESPACE,
  PAYMENT_METHOD_MODAL_NAMESPACE,
  REVIEW_CHARGES_MODAL_NAMESPACE,
  RECEIPT_INFO_MODAL_NAMESPACE,
  PAYMENT_RECEIPT_NAMESPACE,
  PAYSLIP_NAMESPACE,
  MANAGE_PAYMENT_METHODS_MODAL,
  PAYMENT_DATE_MODAL,
  UNSUBSCRIBE_ALERTS,
  LINK_EXPIRED_NAMESPACE,
  RECENT_PAYMENTS_NAMESPACE,
  SESSION_TIMEOUT,
  LOOKUP_NAMESPACE,
  LOOKUP_INFO_IMAGE_MODAL_NAMESPACE,
  PAYABLE_SELECT,
  SELECT_PAYMENT_METHOD_MODAL_NAMESPACE,
  SEARCH_PATH_NAMESPACE,
  PAYABLE_REVIEW_NAMESPACE,
  ITEM_VOIDED_ARCHIVED_NAMESPACE,
  UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE
} from "../constants/i18n-namespaces";
import {
  initResources,
  ENGLISH,
  FRENCH,
  SPANISH,
  // SupportedLanguages,
} from "kubra-labels";

const localResources /*: SupportedLanguages*/ = {
  [ENGLISH]: {
    [COMMON_NAMESPACE]: enCommon,
    [MENU_NAMESPACE]: enMenu,
    [LANGUAGE_MODAL_NAMESPACE]: enLanguageModal,
    [ABOUT_MODAL_NAMESPACE]: enAboutModal,
    [BILLER_LOGO_NAMESPACE]: enBillerLogo,
    [VALIDATE_NAMESPACE]: enValidate,
    [BILL_MODAL_NAMESPACE]: enBillModal,
    [HELP_MODAL_NAMESPACE]: enHelpModal,
    [BALANCE_NAMESPACE]: enBalanceFrame,
    [CONTACT_TOC_FOOTER]: enContactTocFooter,
    [DONATION]: enDonation,
    [BANK_ACCCOUNT_MODAL]: enBankAccountModal,
    [PAYABLE_DETAILS_NAMESPACE]: enPayableDetails,
    [CREDIT_DEBIT_MODAL]: enCreditDebitModal,
    [CASH_MODAL]: enCashModal,
    [BARCODE_VIEW]: enBarcodeView,
    [EMAIL_VIEW]: enEmailView,
    [SMS_VIEW]: enSmsView,
    [RETAILER_VIEW]: enRetailerView,
    [PAYMENT_AMOUNT_MODAL_NAMESPACE]: enPaymentAmountModal,
    [PAYMENT_METHOD_MODAL_NAMESPACE]: enPaymentMethodModal,
    [REVIEW_CHARGES_MODAL_NAMESPACE]: enReviewChargesModal,
    [RECEIPT_INFO_MODAL_NAMESPACE]: enReceiptInfoModal,
    [PAYMENT_RECEIPT_NAMESPACE]: enPaymentReceipt,
    [PAYSLIP_NAMESPACE]: enPayslipView,
    [MANAGE_PAYMENT_METHODS_MODAL]: enManagePaymentMethodsModal,
    [PAYMENT_DATE_MODAL]: enPaymentDateModal,
    [UNSUBSCRIBE_ALERTS]: enUnsubscribeAlerts,
    [LINK_EXPIRED_NAMESPACE]: enLinkExpired,
    [RECENT_PAYMENTS_NAMESPACE]: enRecentPayments,
    [SESSION_TIMEOUT]: enSessionTimeout,
    [LOOKUP_NAMESPACE]: enLookup,
    [FREEFORM_NAMESPACE]: enFreeform,
    [ORDER_NAMESPACE]: enOrder,
    [LOOKUP_INFO_IMAGE_MODAL_NAMESPACE]: enLookupInfoImageModal,
    [PAYABLE_SELECT]: enPayableSelect,
    [SELECT_PAYMENT_METHOD_MODAL_NAMESPACE]: enSelectPaymentMethodModal,
    [SEARCH_PATH_NAMESPACE]: enSearchPath,
    [PAYABLE_REVIEW_NAMESPACE]: enPayableReview,
    [ITEM_VOIDED_ARCHIVED_NAMESPACE]: enItemVoidedArchived,
    [UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE]: enUnableToLoadAmountsModal,
  },
  [SPANISH]: {
    [COMMON_NAMESPACE]: esCommon,
    [MENU_NAMESPACE]: esMenu,
    [LANGUAGE_MODAL_NAMESPACE]: esLanguageModal,
    [ABOUT_MODAL_NAMESPACE]: esAboutModal,
    [BILLER_LOGO_NAMESPACE]: esBillerLogo,
    [VALIDATE_NAMESPACE]: esValidate,
    [BILL_MODAL_NAMESPACE]: esBillModal,
    [HELP_MODAL_NAMESPACE]: esHelpModal,
    [BALANCE_NAMESPACE]: esBalanceFrame,
    [CONTACT_TOC_FOOTER]: esContactTocFooter,
    [DONATION]: esDonation,
    [BANK_ACCCOUNT_MODAL]: esBankAccountModal,
    [PAYABLE_DETAILS_NAMESPACE]: esPayableDetails,
    [CREDIT_DEBIT_MODAL]: esCreditDebitModal,
    [CASH_MODAL]: esCashModal,
    [BARCODE_VIEW]: esBarcodeView,
    [EMAIL_VIEW]: esEmailView,
    [SMS_VIEW]: esSmsView,
    [RETAILER_VIEW]: esRetailerView,
    [PAYMENT_AMOUNT_MODAL_NAMESPACE]: esPaymentAmountModal,
    [PAYMENT_METHOD_MODAL_NAMESPACE]: esPaymentMethodModal,
    [REVIEW_CHARGES_MODAL_NAMESPACE]: esReviewChargesModal,
    [RECEIPT_INFO_MODAL_NAMESPACE]: esReceiptInfoModal,
    [PAYMENT_RECEIPT_NAMESPACE]: esPaymentReceipt,
    [PAYSLIP_NAMESPACE]: esPayslipView,
    [MANAGE_PAYMENT_METHODS_MODAL]: esManagePaymentMethodsModal,
    [PAYMENT_DATE_MODAL]: esPaymentDateModal,
    [UNSUBSCRIBE_ALERTS]: esUnsubscribeAlerts,
    [LINK_EXPIRED_NAMESPACE]: esLinkExpired,
    [RECENT_PAYMENTS_NAMESPACE]: esRecentPayments,
    [SESSION_TIMEOUT]: esSessionTimeout,
    [LOOKUP_NAMESPACE]: esLookup,
    [ORDER_NAMESPACE]: esOrder,
    [FREEFORM_NAMESPACE]: esFreeform,
    [LOOKUP_INFO_IMAGE_MODAL_NAMESPACE]: esLookupInfoImageModal,
    [PAYABLE_SELECT]: esPayableSelect,
    [SELECT_PAYMENT_METHOD_MODAL_NAMESPACE]: esSelectPaymentMethodModal,
    [SEARCH_PATH_NAMESPACE]: esSearchPath,
    [PAYABLE_REVIEW_NAMESPACE]: esPayableReview,
    [ITEM_VOIDED_ARCHIVED_NAMESPACE]: esItemVoidedArchived,
    [UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE]: esUnableToLoadAmountsModal,
  },
  [FRENCH]: {
    [COMMON_NAMESPACE]: frCommon,
    [MENU_NAMESPACE]: frMenu,
    [LANGUAGE_MODAL_NAMESPACE]: frLanguageModal,
    [ABOUT_MODAL_NAMESPACE]: frAboutModal,
    [BILLER_LOGO_NAMESPACE]: frBillerLogo,
    [VALIDATE_NAMESPACE]: frValidate,
    [BILL_MODAL_NAMESPACE]: frBillModal,
    [HELP_MODAL_NAMESPACE]: frHelpModal,
    [BALANCE_NAMESPACE]: frBalanceFrame,
    [CONTACT_TOC_FOOTER]: frContactTocFooter,
    [DONATION]: frDonation,
    [BANK_ACCCOUNT_MODAL]: frBankAccountModal,
    [PAYABLE_DETAILS_NAMESPACE]: frPayableDetails,
    [CREDIT_DEBIT_MODAL]: frCreditDebitModal,
    [CASH_MODAL]: frCashModal,
    [BARCODE_VIEW]: frBarcodeView,
    [EMAIL_VIEW]: frEmailView,
    [SMS_VIEW]: frSmsView,
    [RETAILER_VIEW]: frRetailerView,
    [PAYMENT_AMOUNT_MODAL_NAMESPACE]: frPaymentAmountModal,
    [PAYMENT_METHOD_MODAL_NAMESPACE]: frPaymentMethodModal,
    [REVIEW_CHARGES_MODAL_NAMESPACE]: frReviewChargesModal,
    [RECEIPT_INFO_MODAL_NAMESPACE]: frReceiptInfoModal,
    [PAYMENT_RECEIPT_NAMESPACE]: frPaymentReceipt,
    [PAYSLIP_NAMESPACE]: frPayslipView,
    [MANAGE_PAYMENT_METHODS_MODAL]: frManagePaymentMethodsModal,
    [PAYMENT_DATE_MODAL]: frPaymentDateModal,
    [UNSUBSCRIBE_ALERTS]: frUnsubscribeAlerts,
    [LINK_EXPIRED_NAMESPACE]: frLinkExpired,
    [RECENT_PAYMENTS_NAMESPACE]: frRecentPayments,
    [SESSION_TIMEOUT]: frSessionTimeout,
    [LOOKUP_NAMESPACE]: frLookup,
    [ORDER_NAMESPACE]: frOrder,
    [FREEFORM_NAMESPACE]: frFreeform,
    [LOOKUP_INFO_IMAGE_MODAL_NAMESPACE]: frLookupInfoImageModal,
    [PAYABLE_SELECT]: frPayableSelect,
    [SELECT_PAYMENT_METHOD_MODAL_NAMESPACE]: frSelectPaymentMethodModal,
    [SEARCH_PATH_NAMESPACE]: frSearchPath,
    [PAYABLE_REVIEW_NAMESPACE]: frPayableReview,
    [ITEM_VOIDED_ARCHIVED_NAMESPACE]: frItemVoidedArchived,
    [UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE]: frUnableToLoadAmountsModal,
  },
};

export const resources = initResources(localResources);

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnObjects: true, // return objects instead of null for missing keys
    interpolation: {
      escapeValue: false, // disable escaping of values
    },
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
    supportedLngs: ["en-US", "es-US", "fr-CA"],
    fallbackLng: "en-US",
    resources,
    react: {
      transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
    ns: [SYSTEM, CLIENT_WEB, CLIENT_MOBILE],
    defaultNS: CLIENT_WEB,
    fallbackNS: [SYSTEM, CLIENT_WEB, CLIENT_MOBILE],
    backend: {
      loadPath: (language: string[], namespace: string[]) => {
        console.log("loadPath", language, namespace);
        const languageInUrl = language[0].toLowerCase().replace("-", ".");
        if (namespace[0] === SYSTEM) {
          return `/label-management/system/ezpay.web.${languageInUrl}.json`;
        } else if (
          namespace[0] === CLIENT_WEB ||
          namespace[0] === CLIENT_MOBILE
        ) {
          return `/label-management/a8c2b204-1563-4a9a-9581-72f0cf71e5ef/sandbox/ezpay.${namespace}.${languageInUrl}.json`;
        } else if (namespace[0].startsWith("krn")) {
          return `/label-management/a8c2b204-1563-4a9a-9581-72f0cf71e5ef/sandbox/${namespace}.web.${languageInUrl}.json`;
        }
        return `/label-management/system/ezpay.web.${languageInUrl}.json`;
      },
    },
  })
  .catch((error: Error) => {
    console.error(
      "Unexpected error initializing internationalization",
      error.message
    );
  });

export default i18n;
